import svg4everybody from 'svg4everybody';
import Swiper from 'swiper';
import Pikaday from 'pikaday/pikaday';
import './plugins/jquery.dotdotdot';
import './plugins/jquery.fancybox';

import './video'
import './contest-video'

function mainHeight() {
  let windowHeight = $(window).outerHeight();

  let headerHeight = $('.header').outerHeight() || 0;
  let adTopHeight = $('.ad--top').outerHeight(true) || 0;
  let adBottomHeight = $('.ad--bottom').outerHeight(true) || 0;
  let footerHeight = $('.footer').outerHeight() || 0;

  $('.main').css('min-height', windowHeight - adTopHeight - headerHeight - adBottomHeight - footerHeight);
}

$(function () {
  svg4everybody();

  if ($.fn.dotdotdot) {
    $(".ellipsis").dotdotdot({
      tolerance: 5
    });
  }

  if ($.fn.fancybox) {
    $("[data-fancybox]").fancybox({
      closeBtn: true,
      slideShow: false,
      fullScreen: false,
      thumbs: false,
      youtube: {
        controls: 1,
        showinfo: 0
      },
    });

    $('[data-fancybox="gallery"]').fancybox();
  }



  let swiperButtons = containerSelector => ({
    navigation: {
      prevEl: `${containerSelector} .carousel__button--prev`,
      nextEl: `${containerSelector} .carousel__button--next`,
    }
  });

  new Swiper('.carousel--branding .carousel__container', {
    slidesPerView: 'auto',
    effect: 'fade',
    loop: true,
  });

  new Swiper('.carousel--article .carousel__container', {
    slidesPerView: 'auto',
    ...swiperButtons('.carousel--article '),
    loop: true,
  });

  new Swiper('.carousel--frames .carousel__container', {
    slidesPerView: 'auto',
    ...swiperButtons('.carousel--frames '),
  });

  new Swiper('.carousel--programs .carousel__container', {
    slidesPerView: 'auto',
    ...swiperButtons('.carousel--programs '),
  });

  new Swiper('.carousel--teleprogram .carousel__container', {
    slidesPerView: 'auto',
    ...swiperButtons('.carousel--teleprogram '),
    spaceBetween: 10,
  });

  $(".carousel--video").each(function (index, element) {
    let $this = $(this);

    $this.addClass("carousel--video-" + index);
    let swiper = new Swiper(".carousel--video-" + index + ' .carousel__container', {
      slidesPerView: 4,
      spaceBetween: 20,
      ...swiperButtons(".carousel--video-" + index),

      breakpoints: {
        560: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        767: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        979: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: 3,
          spaceBetween: 20,
        }
      }
    });
  });

  let swiper = new Swiper('.carousel--presenters .carousel__container', {
    slidesPerView: 4,
    spaceBetween: 20,
    ...swiperButtons('.carousel--presenters'),

    breakpoints: {
      560: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      767: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      979: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1199: {
        slidesPerView: 3,
        spaceBetween: 20,
      }
    }
  });

  // $(".carousel--presenters").each(function(index, element){
  //   let $this = $(this);
  //
  //   $this.addClass("carousel--presenters-" + index);
  //
  // });

  if ($.fn.mCustomScrollbar) {
    //$(".online .online__list").mCustomScrollbar({
    //    axis: "y",
    //    theme: "minimal-dark"
    //});
  }


  new Swiper('.carousel--promo .carousel__container', {
    slidesPerView: 'auto',
    ...swiperButtons('.carousel--promo '),
    autoplay: 5000,
    loop: true,
    pagination: {
      el: '.carousel--promo .carousel__pagination',
      clickable: true,
    },
  });

  new Swiper('.carousel--video-playlist .carousel__container', {
    slidesPerView: 4,
    ...swiperButtons('.carousel--video-playlist '),
    simulateTouch: false,
    breakpoints: {
      560: {
        slidesPerView: 1
      },
      767: {
        slidesPerView: 2
      },
      979: {
        slidesPerView: 3
      },
      1199: {
        slidesPerView: 3
      }
    }
  });

  new Swiper('.carousel--photo-best .carousel__container', {
    slidesPerView: 'auto',
    ...swiperButtons('.carousel--photo-best '),
    pagination: {
      el: '.carousel--photo-best .carousel__pagination',
      clickable: true,
    },
    autoHeight: true
  });

  new Swiper('.carousel--photo-project .carousel__container', {
    slidesPerView: 'auto',
    ...swiperButtons('.carousel--photo-project '),
    pagination: {
      el: '.carousel--photo-project .carousel__pagination',
      clickable: true,
    },
  });

  /* Popup call */
  $('.js-popup-link-button').each(function (i, item) {
    $(item).attr('href', $(item).data('href'));
  });

  $(document).on('click', '.js-popup-link', function (e) {
    e.preventDefault();

    $('.popup').removeClass('popup--active');

    let popupName = $(this).data('popup');
    let popup = $('#popup-' + popupName);

    $('body').addClass('fixed');
    $('.popup-bg').addClass('popup-bg--active');
    $('.popup-overlay').addClass('popup-overlay--active');

    popup.addClass('popup--active');

    let href = $(e.currentTarget).attr('href') || $(e.currentTarget).data('href');
    console.log(href);
    if (href !== undefined) {
      $('.js-redirect-input').val(href);
      uLoginParams.redirect_uri = encodeURIComponent(redirectBase + '?target=' + href);
    }
    $('.ulogin').removeAttr('data-ulogin-inited');
    uLogin.customInit('uLogin_0', 'uLogin_1', 'uLogin_2', uLoginParams);
  });

  $(document).on('click', '.js-popup-close', function (e) {
    e.preventDefault();

    $('body').removeClass('fixed');
    $('.popup-bg').removeClass('popup-bg--active');
    $('.popup-overlay').removeClass('popup-overlay--active');
    $('.popup').removeClass('popup--active');
  });

  $(document).on('click', '.js-accordion-link', function (e) {
    e.preventDefault();

    let itemActive = $(this).parents('.js-accordion').hasClass('item_active');

    $(this).parents('.js-accordion').removeClass('item_active');
    $(this).parents('.js-accordions').find('.js-accordion').removeClass('item_active');

    if (!itemActive) {
      $(this).parents('.js-accordion').addClass('item_active');
    }
  });

  /* Открытие меню на планшете и телефоне */

  $(document).on('click', '.js-burger', function () {
    $('.burger').toggleClass('burger--active');
    $('.header__panel').toggleClass('header__panel--active');
  });

  $(document).on('click', '.menu--mobile .menu__link', function () {
    $('.burger').removeClass('burger--active');
    $('.header__panel').removeClass('header__panel--active');
  });

  // $('.js-nomination-picker').on('click', (e) => {
  //   let target = $(e.currentTarget);
  //   if (target.hasClass('filter-category__button--active')) {
  //     $(`.grid-video__item`).show();
  //     $('.js-nomination-picker').removeClass('filter-category__button--active');
  //     return;
  //   }
  //   let id = target.data('id');
  //   $(`.grid-video__item`).hide();
  //   $(`.grid-video__item[data-nomination=${id}]`).show();
  //   $('.js-nomination-picker').removeClass('filter-category__button--active');
  //   target.addClass('filter-category__button--active');
  // });

  /* article additional forced fixes */
  $(".detail__content iframe[src*='youtube.com']").wrap('<div class="detail__video"></div>');
  $(".detail__content.js-news_detail_content a").attr('target', '_blank');

  mainHeight();
  $(window).resize(function () {
    mainHeight();
  });

  $('.js-logout').on('click', () => {
    $.post('/ajax/logout', () => {
      location.reload();
    });
  });

  /* calendar and calendar clicking */
  let calendar = document.getElementById('calendar__widget');
  if (calendar !== null) {
    // let picker = new Pikaday({
    //   field: document.getElementById('calendar__input'),
    //   firstDay: 1,
    //   minDate: new Date(),
    //   maxDate: new Date(lastDate),
    //   yearRange: [2017, 2030],
    //   bound: false,
    //   container: calendar,
    //   i18n: {
    //     previousMonth: 'Предыдущий месяц',
    //     nextMonth: 'Следующий месяц',
    //     months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    //     weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Чеверг', 'Пятница', 'Суббота'],
    //     weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
    //   },
    //   onSelect: function () {
    //     $('.js-schedule-date-slide').removeClass('item_active');
    //     $('.js-schedule-date-slide[data-date=' + date + ']').addClass('item_active');
    //     fetch(`/ajax/getScheduleDay?date=${date}`)
    //       .then(data => data.text())
    //       .then(data => {
    //         $('.teleprogram__content').html(data);
    //         if (selectedItem) {
    //           let elem = document.querySelector('#schedule-item-' + selectedItem);
    //           $(elem).addClass('item_active');
    //           console.log(elem);
    //           elem.scrollIntoView({behavior: "smooth", block: "start"});
    //         }
    //       });
    //   }
    // });
    // picker.setDate(selectedDate || '');

    let date = this.getMoment().format('YYYY-MM-DD');
    $('.js-schedule-date-slide').on('click', e => {
      picker.setDate(e.currentTarget.getAttribute('data-date'));
    });
    $('.js-schedule-date-slide[data-date=' + date + ']').trigger('click');
  }

  /* news loading with show more */
  $('.js-news-show-more').on('click', function () {
    this.loading = true;
    let that = this;
    if (this.isLoading || false) {
      return;
    } else {
      this.isLoading = true;
      $(that).html('Загружается');
    }
    console.log(that.getAttribute('data-next-page'));
    fetch(`/ajax/getNewsPage?page=${that.getAttribute('data-next-page')}`)
      .then(data => data.text())
      .then(data => {
        that.setAttribute('data-next-page', parseInt(that.getAttribute('data-next-page')) + 1);
        $('.js-news-list').append(data);
        that.isLoading = false;
        $(that).html('Показать еще');
      });
  });

  $('.js-articles-show-more').on('click', function () {
    this.loading = true;
    let that = this;
    if (this.isLoading || false) {
      return;
    } else {
      this.isLoading = true;
      $(that).html('Загружается');
    }
    fetch(`/ajax/getArticlesPage?page=${that.getAttribute('data-next-page')}`)
      .then(data => data.text())
      .then(data => {
        that.setAttribute('data-next-page', parseInt(that.getAttribute('data-next-page')) + 1);
        $('.js-news-list').append(data);
        that.isLoading = false;
        $(that).html('Показать еще');
      });
  });

  $('.js-photo-projects-show-more').on('click', function () {
    this.loading = true;
    let that = this;
    if (this.isLoading || false) {
      return;
    } else {
      this.isLoading = true;
      $(that).html('Загружается');
    }

    let articlesCountBefore = $('.photo-notes__list .photo-notes__item').length;
    fetch(`/ajax/getPhotoprojectPage?page=${that.getAttribute('data-next-page')}`)
      .then(data => data.text())
      .then(data => {
        that.setAttribute('data-next-page', parseInt(that.getAttribute('data-next-page')) + 1);
        $('.photo-notes__list').append(data);
        that.isLoading = false;
        let articlesCountAfter = $('.photo-notes__list .photo-notes__item').length;
        if (articlesCountAfter - articlesCountBefore < 3) {
          $(that).remove();
        } else {
          $(that).html('смотреть больше');
        }
      });
  });
});


(function (document, window, index) {
  let inputs = document.querySelectorAll('.file__input');
  Array.prototype.forEach.call(inputs, function (input) {
    let label = input.nextElementSibling,
      labelVal = label.innerHTML;

    input.addEventListener('change', function (e) {
      let fileName = '';
      if (this.files && this.files.length > 1)
        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
      else
        fileName = e.target.value.split('\\').pop();

      if (fileName)
        label.querySelector('span').innerHTML = fileName;
      else
        label.innerHTML = labelVal;
    });

    // Firefox bug fix
    input.addEventListener('focus', function () { input.classList.add('has-focus'); });
    input.addEventListener('blur', function () { input.classList.remove('has-focus'); });
  });
}(document, window, 0));



// WEBPACK FOOTER //
// ./src/static/scripts/script.js